const HEADER_MOD = {
    "How do you achieve reliable enterprise-wide accounting?": {
        header: "Lorem ipsum",
        negCopy:"Automatically harmonize enterprise-wide accounting into a common general ledger.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
     "Wie führen Sie eine zuverlässige unternehmensweite Buchhaltung durch?": {
        header: "Fusionen und Übernahmen: Buchhaltung harmonisieren",
        negCopy:"Harmonisieren Sie die unternehmensweite Buchhaltung automatisch mit dem gemeinsamen Hauptbuch.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-ma-starter-kit-de",
        negLinkTxt:"Erfahren Sie, wie Sie loslegen können",
    },
    "Comment assurez-vous la fiabilité de votre comptabilité dans toute l’entreprise ?": {
        header: "Fusions et Acquisitions: Harmoniser la comptabilité",
        negCopy:"Harmonisez automatiquement la comptabilité de toute l’entreprise au sein d’un grand livre commun.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-business-model-starter-kit-fr?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Découvrez comment ici",
    },
    "Как вы обеспечиваете надежность ведения бухгалтерского учета на предприятии?": {
        header: "Слияния и поглощения: Гармонизация учета",
        negCopy:"Автоматически гармонизируйте бухгалтерский учет в масштабе всего предприятия в Главной книге.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Узнать, с чего начать",
    },
    "Kurum genelinde güvenilir muhasebeyi nasıl gerçekleştiriyorsunuz?": {
        header: "M&A: Muhasebeyi uyumlu hale getirin",
        negCopy:"İşletme çapında muhasebeyi otomatik olarak ortak bir genel muhasebeye uyumlu hale getirin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Nasıl başlayacağınızı öğrenin",
    },
    "Come ottenete una contabilità affidabile a livello aziendale?": {
        header: "M&A: armonizza la contabilità",
        negCopy:"Armonizza automaticamente la contabilità generale a livello aziendale e di Gruppo in un General Ledger comune.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Scopri come iniziare",
    },
    "¿Cómo consigue una contabilidad fiable en toda la empresa?": {
        header: "Fusiones y Adq.: contabilidad armonizada",
        negCopy:"Armonice automáticamente la contabilidad de toda la empresa en un libro mayor común.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Averigüe cómo empezar",
    },
        "Como é assegurada uma contabilidade confiável em toda a sua organização?": {
        header: "M&A: Harmonize a contabilidade",
        negCopy:"Harmonize automaticamente a contabilidade de toda a organização em um registro geral comum.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-ma-starter-kit-br",
        negLinkTxt:"Saiba como começar",
    },
        "¿Cómo alcanzarías una contabilidad empresarial confiable?": {
        header: "M&A: Armonizar la contabilidad",
        negCopy:"Armoniza automáticamente la contabilidad de toda la empresa en un libro mayor general común.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-ma-starter-kit-sp",
        negLinkTxt:"Descubre cómo empezar a utilizar",
    },
    "How do you perform scenario modeling and long-range plans?": {
        header: "design for customer centricity",
        negCopy:"Gain customer insights to deliver products and services they value.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"See how in this quick tour",    
    },
        "Wie führen Sie Szenariomodellierung und langfristige Pläne durch?": {
        header: "Szenariomodellierung",
        negCopy:"Modellieren und evaluieren Sie Finanzszenarien, um fundierte Entscheidungen zu treffen und in einer sich laufend verändernden Geschäftswelt Erwartungen zu übertreffen.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Erfahren Sie in dieser Quick Tour, wie das geht",    
    },
        "Êtes-vous en mesure de modéliser des scénarios et de planifier à long terme ?": {
        header: "Modélisation de scénarios",
        negCopy:"Modélisez et évaluez rapidement des scénarios financiers pour prendre des décisions éclairées et vous surpasser dans le contexte actuel.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
        "Как осуществляется сценарное моделирование и долгосрочное планирование в компании?": {
        header: "Моделирование сценариев",
        negCopy:"Быстро моделируйте и оценивайте финансовые сценарии, чтобы принимать обоснованные решения и показывать высокую производительность в постоянно меняющейся бизнес-среде. ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Смотреть краткую презентацию, чтобы узнать, как это сделать",    
    },
        "Senaryo modellemeyi ve uzun vadeli planları nasıl yürütüyorsunuz?": {
        header: "Senaryo modelleme",
        negCopy:"Bilgiye dayalı kararlar vermek ve günümüzün sürekli değişen iş ortamında yüksek performans göstermek için mali senaryolarınızı hızlıca modelleyin ve değerlendirin.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Bu hızlı turda bunu nasıl olacağını görün",    
    },
        "Come sviluppate la modellazione degli scenari e i piani a lungo termine?": {
        header: "Modellazione degli scenari ",
        negCopy:"Modella e valuta rapidamente gli scenari economico-finanziari per prendere decisioni informate e ottenere performance migliori in un contesto in continua evoluzione.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Scopri come in questo breve tour",    
    },
        "¿Cómo simula los modelos de escenarios y los planes a largo plazo?": {
        header: "Simulación de escenarios",
        negCopy:"Realice simulaciones y evalúe escenarios financieros con rapidez para tomar decisiones informadas y obtener un rendimiento superior en un panorama en constante cambio.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Descubra cómo con la demostración rápida",    
    },
        "Como a modelagem de cenário e os planos de longo prazo são executados?": {
        header: "Modelagem de cenários",
        negCopy:"Modele e avalie rapidamente cenários financeiros para tomar decisões informadas e ter desempenho superior no atual cenário de negócios em constante evolução.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Veja como nesse tour rápido",    
    },
       "¿Cómo se realiza el análisis del panorama y los planes a largo plazo?": {
        header: "Análisis de panoramas",
        negCopy:"Analiza y evalúa rápidamente panoramas financieros para tomar decisiones informadas y superar el actual panorama empresarial en constante evolución actual.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Descubre cómo en este recorrido rápido",    
    },
        "How do you manage your financial close process?": {
        header: "Financial Close Process",
        negCopy:"Move toward an automated, connected close for faster, more accurate, and transparent reporting to support big decisions.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-auto-close-starter-kit?topic=Accelerate%20an%20Automated%20Close",
        negLinkTxt:"Find out where to start",    
    },
       "Wie läuft der Finanzabschluss ab?": {
        header: "Finanzabschluss",
        negCopy:"Setzen Sie auf einen automatisierten, zusammenhängenden Abschluss für ein schnelleres, genaueres und transparenteres Reporting zur Unterstützung wichtiger Entscheidungen.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-auto-close-starter-kit-de",
        negLinkTxt:"Erfahren Sie, wo Sie beginnen sollten",    
    },
        "Comment gérez-vous votre clôture financière ?": {
        header: "Processus de clôture financière",
        negCopy:"Adoptez un processus de clôture automatisé et connecté pour profiter d’un reporting précis et transparent qui facilite la prise de décisions importantes.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-auto-close-starter-kit-fr",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
        "Как организован процесс управления финансовым закрытием в вашей компании?": {
        header: "Процесс финансового закрытия",
        negCopy:"Переходите на автоматизированное закрытие, учитывающее все процессы, что обеспечит быстрое формирование точной и прозрачной отчетности для поддержки важных решений.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-auto-close-starter-kit?topic=Accelerate%20an%20Automated%20Close",
        negLinkTxt:"Узнать, с чего начать",    
    },
        "Finansal kapanış sürecinizi nasıl yönetiyorsunuz?": {
        header: "Finansal dönem kapanış süreci",
        negCopy:"Büyük kararları destekleme açısından daha hızlı, daha doğru ve şeffaf raporlama için otomatik, entegre bir kapanışa yönelin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-auto-close-starter-kit?topic=Accelerate%20an%20Automated%20Close",
        negLinkTxt:"Nerden başlayacağınızı öğrenin",    
    },
          "Come viene gestito il processo di closing contabile?": {
        header: "Processo di closing contabile",
        negCopy:"Passa a una chiusura contabile automatica e connessa, con una consuntivazione e un reporting più rapidi, accurati e trasparenti da portare a supporto delle decisioni.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-auto-close-starter-kit?topic=Accelerate%20an%20Automated%20Close",
        negLinkTxt:"Scopri da dove cominciare",    
    },
    "¿Cómo es la gestión del cierre financiero?": {
        header: "Proceso de cierre financiero",
        negCopy:"Avance hacia un cierre automatizado y conectado para generar rápidamente informes más precisos y transparentes que respalden las decisiones importantes.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-auto-close-starter-kit?topic=Accelerate%20an%20Automated%20Close",
        negLinkTxt:"Averigüe por dónde empezar",    
    },
        "Como você gerencia o processo de fechamento financeiro?": {
        header: "Processo de fechamento financeiro",
        negCopy:"Avance em direção a um fechamento automatizado e conectado para obter relatórios mais rápidos, precisos e transparentes que forneçam suporte para grandes decisões.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-auto-close-starter-kit-br",
        negLinkTxt:"Descubra por onde começar",    
    },
        "¿Cómo gestionas el proceso de cierre financiero?": {
        header: "Proceso de cierre financiero",
        negCopy:"Avanza hacia un cierre automatizado y conectado para obtener informes más rápidos, precisos y transparentes, que respalden grandes decisiones.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-auto-close-starter-kit-sp",
        negLinkTxt:"Descubre dónde empezar",    
    },
        "Describe financial processing in the quote to cash (QTC) cycle.": {
        header: "Quote to Cash",
        negCopy:"Improve cash management with connected, standardized, digitized quote-to-cash processes across the business.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"See how in this tour",    
    },
        "Beschreiben Sie die Finanzabwicklung im Quote-to-Cash-Zyklus (QTC).": {
        header: "Quote-to-Cash",
        negCopy:"Verbessern Sie das Cash-Management mit zusammenhängenden, standardisierten, digitalisierten Quote-to-Cash-Prozessen im gesamten Unternehmen.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Erfahren Sie in dieser Quick Tour, wie das geht.",    
    },
         "Décrivez vos opérations financières du cycle QTC (du devis à l’encaissement).": {
        header: "Du devis à l’encaissement (QTC)",
        negCopy:"Améliorez la gestion de votre trésorerie à l’aide de processus connectés, normalisés et numérisés communs à toute l’entreprise.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
         "Как в вашей компании организован процесс Quote-to-Cash (QTC)?": {
        header: "От предложения до оплаты (QTC)",
        negCopy:"Повысьте эффективность управления денежными средствами за счет взаимосвязи, стандартизации и цифрового формата всех процессов компании при заключении финансовых сделок.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Смотреть презентацию, чтобы узнать, как это сделать",    
    },
         "Tekliften Nakde (QTC) döngüsündeki mali işlemi tanımlayın.": {
        header: "Tekliften Nakde",
        negCopy:"İşletmenin tamamında bağlantılı, standart, dijital tekliften nakde süreçleriyle nakit yönetiminizi iyileştirin.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Bu turda bunu nasıl olacağını görün",    
    },
         "Descrivi il Ciclo attivo, in particolare il processo contabile \"Quote-to-Cash\"(QTC).": {
        header: "Ciclo attivo (Quote-to-Cash)",
        negCopy:"Migliora la gestione della liquidità generata dal ciclo attivo con processi Quote-to-Cash connessi, standardizzati e digitalizzati per tutta l'azienda.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Scopri come in questo tour",    
    },
         "Describa el proceso financiero en el ciclo de cotización en efectivo (QTC).": {
        header: "Cotización en efectivo (QTC)",
        negCopy:"Mejore la gestión del efectivo con procesos de cotización en efectivo estándar, conectados y digitalizados en toda la empresa.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Descubra cómo con esta demostración",    
    },
         "Descreva o processamento financeiro no ciclo quote-to-cash (QTC).": {
        header: "Quote-to-Cash",
        negCopy:"Melhore a gestão de caixa com processos quote-to-cash conectados, padronizados e digitalizados em toda a organização.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Veja como nesse tour",    
    },
         "Describe el procesamiento financiero en el ciclo de cotización en efectivo (QTC).": {
        header: "Quote-to-Cash",
        negCopy:"Mejora la gestión de efectivo con procesos de cotización en efectivo conectados, estandarizados y digitalizados.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-fins-deldecisve/index.html",
        negLinkTxt:"Descubre cómo en este recorrido",    
    },
        "Which describes your audit, risk and compliance processes?": {
        header: "Risk Management",
        negCopy:"Integrate risk management into your culture and business processes with automated security analysis, digitized audits and compliance.",
        negLink: "https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt: "Learn how to get started",    
    },
        "Wie würden Sie Ihre Prüf-, Risiko- und Compliance-Prozesse beschreiben?": {
        header: "Risk Management",
        negCopy:"Integrieren Sie ein Risikomanagement mit automatisierter Sicherheitsanalyse, Compliance und digitalisierten Prüfungen in Ihre Unternehmenskultur und Unternehmensprozesse.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-risk-starter-kit-de",
        negLinkTxt:"Erfahren Sie, wie Sie loslegen können",    
    },
       "Décrivez vos processus d’audit, de gestion des risques et de conformité.": {
        header: "Gestion des risques",
        negCopy:"Intégrez la gestion des risques dans votre culture et vos processus avec une analyse automatisée de la sécurité, des audits numérisés et des normes de conformité.",
        negLink: "https://explore.oracle.com/big-moves-fr/bm-risk-starter-kit-fr",
        negLinkTxt: "Découvrez comment vous lancer",    
    },
     "Охарактеризуйте процессы аудита компании, управления рисками и соответствием?": {
        header: "Управление рисками",
        negCopy:"Внедрите управление рисками в бизнес-процессы компании посредством автоматизированного контроля безопасности, цифрового аудита и соответствия требованиям.",
        negLink: "https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt: "Узнать, с чего необходимо начать",    
    },
     "Denetim, risk ve uygunluk süreçlerinizi en iyi hangisi tanımlıyor?": {
        header: "Risk yönetimi",
        negCopy:"Otomatik güvenlik analizleri, dijital denetimler ve uygunluk işlemleriyle kültürünüze ve işletme süreçlerinize risk yönetimini entegre edin.",
        negLink: "https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt: "Nasıl başlayacağınızı öğrenin",    
    },
     "Quale risposta descrive meglio i vostri processi di audit, rischio e conformità?": {
        header: "Gestione del rischio",
        negCopy:"Integra la gestione del rischio nella cultura e nei processi aziendali, con analisi automatizzate della sicurezza, audit digitalizzati e gestione della conformità.",
        negLink: "https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt: "Scopri come iniziare",    
    },
     "¿Cómo describiría los procesos de auditoría, riesgo y cumplimiento?": {
        header: "Gestión de riesgos",
        negCopy:"Integre la gestión de riesgos en su cultura y procesos empresariales con análisis de seguridad automatizados y auditorías y pruebas de conformidad digitalizados.",
        negLink: "https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt: "Averigüe cómo empezar",    
    },
     "Qual descreve os processos de auditoria, risco e conformidade?": {
        header: "Gestão de riscos",
        negCopy:"Integre a gestão de riscos à sua cultura e aos seus processos de negócios com análise de segurança automatizada, auditorias e conformidade digitalizadas.",
        negLink: "https://explore.oracle.com/big-moves-br/bm-risk-starter-kit-br",
        negLinkTxt: "Saiba como começar",    
    },
     "¿Qué describe tus procesos de auditoría, riesgo y cumplimiento?": {
        header: "Gestión de riesgos",
        negCopy:"Integra la gestión de riesgos en tu cultura y procesos de negocio con análisis de seguridad automatizados, auditorías digitalizadas y cumplimiento.",
        negLink: "https://explore.oracle.com/big-moves-sp/bm-risk-starter-kit-sp",
        negLinkTxt: "Descubre cómo empezar a utilizar",    
    },
    "How easily are trusted enterprise-wide financial reports produced?": {
        header: "M&A: Financial reporting",
        negCopy:"Create  a harmonized, single source of truth for enterprise financial reports.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Download the starter kit here",    
    },
    "Wie leicht lassen sich vertrauenswürdige unternehmensweite Finanzberichte erstellen?": {
        header: "Fusionen und Übernahmen: Rechnungslegung ",
        negCopy:"Erstellen Sie eine abgeglichene, zuverlässige Datenquelle für die Finanzberichte des Unternehmens.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-ma-starter-kit-de",
        negLinkTxt:"Laden Sie das Starter-Kit hier herunter",    
    },
        "Avez-vous un accès simple à des rapports financiers fiables de toute l’entreprise ?": {
        header: "Fusions et Acquisitions: Reporting financier ",
        negCopy:"Créez une source d’informations unique, fiable, et harmonisée pour générer les rapports financiers de l’entreprise.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-business-model-starter-kit-fr?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Obtenez votre kit de démarrage",    
    },
        "Легко ли составлять надежные финансовые отчеты в масштабе всего предприятия?": {
        header: "Слияния и поглощения: Финансовая отчетность",
        negCopy:"Создайте единый унифицированный источник достоверных данных для составления финансовой отчетности предприятия.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Скачать стартовое руководство",    
    },
        "Güvenilir işletme geneli mali raporlar ne kadar kolay hazırlanıyor?": {
        header: "M&A: Finansal Raporlama",
        negCopy:"Kurumsal finansal raporlar için uyumlu, tek bir doğru kaynak oluşturun.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Başlangıç kitini buradan indirin",    
    },
        "Con quale facilità vengono prodotti report finanziari affidabili a livello aziendale?": {
        header: "M&A: Rendicontazione finanziaria ",
        negCopy:"Crea un'unica fonte di dati affidabile in cui è armonizzato tutto il reporting package aziendale.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Scarica lo starter kit qui",    
    },
        "¿Con qué facilidad puede producir informes financieros fiables para su empresa?": {
        header: "Fusiones y Adq.: informes financieros",
        negCopy:"Cree una única fuente de datos armonizada y fiable para los informes financieros de la empresa.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Descargue aquí el kit de inicio",    
    },
        "Com que facilidade os relatórios financeiros confiáveis da empresa são produzidos?": {
        header: "M&A: Relatórios financeiros",
        negCopy:"Crie uma fonte de verdade única e harmonizada para os relatórios financeiros da organização.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-ma-starter-kit-br",
        negLinkTxt:"Baixe o kit inicial aqui",    
    },
        "¿Con qué facilidad puedes producir informes financieros confiables en su empresa?": {
        header: "M&A: Informes financieros",
        negCopy:"Crea una única fuente armonizada para elaborar informes financieros.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-ma-starter-kit-sp",
        negLinkTxt:"Descarga el kit de inicio aquí",    
    },
        "How do you adapt to new business models?": {
        header: "Innovation",
        negCopy:"Now is the time to invest in new business models, products, and services. Learn how to pivot your business models and resources toward the next growth opportunity.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-business-model-starter-kit?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Download your starter kit",    
    },
        "Wie passen Sie sich an neue Geschäftsmodelle an?": {
        header: "Innovation",
        negCopy:"Investieren Sie jetzt in neue Geschäftsmodelle, Produkte und Services. Verändern Sie Geschäftsmodelle und Ressourcen mit Blick auf die nächste Wachstumschance.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-business-model-starter-kit-de?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Laden Sie jetzt Ihr Starter-Kit herunter",    
    },
     "Comment vous adaptez-vous aux nouveaux business models ?": {
        header: "Innovation",
        negCopy:"Il est temps d’investir dans de nouveaux business models, produits et services. Découvrez comment évoluer et profiter de nouvelles opportunités de croissance.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-business-model-starter-kit-fr?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Obtenez votre kit de démarrage",    
    },
         "Как ваша компания адаптируется к новым бизнес-моделям?": {
        header: "Инновации",
        negCopy:"Пришло время инвестиций в новые бизнес-модели, продукты и сервисы.Узнайте, как изменить бизнес-модели и ресурсы, чтобы открыть новые возможности для роста.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-business-model-starter-kit?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Скачать стартовое руководство",    
    },
         "Yeni iş modellerine nasıl ayak uydurursunuz?": {
        header: "İnovasyon",
        negCopy:"Yeni iş modellerine, ürünlerine ve hizmetlerine yatırım yapma zamanı geldi. İş modellerinizi ve kaynaklarınızı sonraki büyüme fırsatına nasıl yönlendireceğinizi öğrenin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-business-model-starter-kit?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Başlangıç kitinizi indirin",    
    },
         "Come vi adattate ai nuovi modelli di business?": {
        header: "Innovazione",
        negCopy:"È il momento di investire in nuovi modelli di business, prodotti e servizi. Scopri come orientare i tuoi modelli e le tue risorse verso ulteriori opportunità di crescita.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-business-model-starter-kit?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Scarica il tuo starter kit",    
    },
         "¿Cómo se adapta a los nuevos modelos de negocio?": {
        header: "Innovación",
        negCopy:"Es el momento de invertir en nuevos modelos de negocio, productos y servicios. Oriente sus modelos de negocio y recursos hacia la próxima oportunidad de crecimiento.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-business-model-starter-kit?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Descargue su kit de inicio",    
    },
         "Como sua organização se adapta aos novos modelos de negócios?": {
        header: "Inovação",
        negCopy:"Agora é a hora de investir em novos modelos de negócios, produtos e serviços. Saiba como dinamizar seus modelos de negócios e recursos para a próxima oportunidade de crescimento.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-business-model-starter-kit-br",
        negLinkTxt:"Baixe seu kit inicial",    
    },
         "¿Cómo te adaptas a los nuevos modelos de negocio?": {
        header: "Innovación",
        negCopy:"Es momento de invertir en nuevos modelos de negocio, productos y servicios. Aprende a orientar tus modelos de negocio y recursos hacia la próxima oportunidad de crecimiento.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-business-model-starter-kit-sp",
        negLinkTxt:"Descarga tu kit de inicio",    
    },
        "What is your evaluation process for M&A and divestitures?": {
        header: "M&A: Acquisition phase",
        negCopy:"Identify merger and acquisition targets and programmatically analyze impact on debt ratio, cash flow, stock price, and other KPIs.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Get your starter kit",    
    },
        "Wie werden Fusionen, Übernahmen sowie Veräußerungen evaluiert?": {
        header: "Fusionen und Übernahmen: Übernahmephase",
        negCopy:"Ermitteln Sie Zielobjekte für Übernahmen und Fusionen und analysieren Sie die Auswirkungen auf Schuldenquote, Cashflow, Aktienpreis und andere KPIs programmatisch.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-ma-starter-kit-de",
        negLinkTxt:"Holen Sie sich Ihr Starter-Kit",
    },
    "Comment évaluez-vous les fusions et acquisitions et les cessions ?": {
        header: "Fusions et acquisitions: Phase d’acquisition",
        negCopy:"Identifiez les cibles et analysez l’impact sur les ratios d’endettement, le cash flow, le cours de l’action et d’autres KPI.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-business-model-starter-kit-fr?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Obtenez votre kit de démarrage",    
    },
        "Как вы оцениваете влияние процессов слияния и поглощения, а также продажи активов?": {
        header: "Слияния и поглощения: Этап поглощения ",
        negCopy:"Определите цели слияния и поглощения и программно проанализируйте их влияние на коэффициент задолженности, на движение денежных средств, на курс акций и на другие KPI.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Получить стартовый пакет",    
    },
        "Şirket birleşmesi ve alımı ve elden çıkarma için değerlendirme süreciniz nedir?": {
        header: "M&A – EDİNİM EVRESİ",
        negCopy:"Şirket birleşme ve satın alma hedeflerini belirleyin ve borç oranı, nakit akışı, hisse fiyatı ve diğer KPI'lar üzerindeki etkisini programlı bir şekilde analiz edin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Başlangıç kitinizi alın",    
    },
        "Qual è il vostro processo di valutazione per M&A e disinvestimenti?": {
        header: "M&A: Fase di acquisizione",
        negCopy:"Identifica gli obiettivi di fusione e acquisizione e analizza in anticipo l'impatto sui covenants e sul merito creditizio, sul cash flow, il P/E ratio e altri KPI.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Ottieni il tuo starter kit",    
    },
        "¿Qué proceso de evaluación aplica en las fusiones, adquisiciones y desinversiones?": {
        header: "Fusiones y Adq.: fase de adquisición ",
        negCopy:"Identifique objetivos M&A y analice programáticamente el impacto en el ratio de deuda, el flujo de caja, el precio de las acciones y otros KPI.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Consiga su kit de inicio",    
    },
        "Como é o seu processo de avaliação de fusões e aquisições e alienações?": {
        header: "M&A: Fase de aquisição",
        negCopy:"Identifique metas de fusões e aquisições e analise programaticamente o impacto sobre o índice de endividamento, fluxo de caixa, preço das ações e outros KPIs.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-ma-starter-kit-br",
        negLinkTxt:"Obtenha seu kit inicial",    
    },
        "¿Cuál es tu proceso de evaluación para fusiones y adquisiciones y desinversiones?": {
        header: "M&A: Fase de adquisición",
        negCopy:"Identifica los objetivos de fusión y adquisición y analizar programáticamente el impacto en el ratio de deuda, el flujo de caja, el precio de las acciones y otros KPI.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-ma-starter-kit-sp",
        negLinkTxt:"Obtén tu kit de inicio",    
    },
        "How connected is your budgeting and planning process?": {
        header: "Integrated business planning",
        negCopy:"Use sophisticated long-range planning and strategic modeling to quickly analyze financial impact, make informed decisions, and outperform in  a constantly-evolving business landscape.  ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"See how in this quick tour",    
    },
        "Wie zusammenhängend ist Ihr Finanzplanungs- und Planungsprozess?": {
        header: "Integrierte Geschäftsplanung",
        negCopy:"Mit langfristiger Planung und strategischen Modellen können Sie finanzielle Auswirkungen analysieren, fundierte Entscheidungen treffen und Erwartungen übertreffen.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Erfahren Sie in dieser Quick Tour, wie das geht",    
    },
    "Le processus de budgétisation et de planification est-il connecté ?": {
        header: "Planification intégrée des activités",
        negCopy:"La planification à long terme et la modélisation stratégique vous permettent d’analyser l’impact financier, prendre des décisions éclairées et booster vos performances.  ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
       "Насколько взаимосвязаны процессы бюджетирования и планирования в вашей компании?": {
        header: "Интегрированное бизнес-планирование",
        negCopy:"Используйте долгосрочное планирование и стратегическое моделирование для анализа финансовых изменений, принятия решений и опережения конкурентов в меняющейся среде.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Смотреть краткую презентацию, чтобы узнать, как это сделать",    
    },
       "Bütçeleme ve planlama süreciniz ne kadar bağlantılı?": {
        header: "ENTEGRE İŞ PLANLAMA",
        negCopy:"Mali etki analizi, bilgiye dayalı kararlar ve sürekli değişen iş ortamında performans sağlamak için sofistike uzun vadeli planlama ve stratejik modelleme kullanın.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Bu hızlı turda bunu nasıl olacağını görün",    
    },
       "Quanto sono connessi i vostri processi di pianificazione e budget?": {
        header: "Pianificazione aziendale integrata",
        negCopy:"Usa la pianificazione integrata e la modellazione strategica per analizzare l'impatto economico-finanziario, prendere decisioni informate e migliorare le performance.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Scopri come in questo breve tour",    
    },
       "¿Están conectados los procesos de presupuestación y planificación?": {
        header: "Planificación comercial integrada",
        negCopy:"Planificar a largo plazo y usar modelos estratégicos para analizar con rapidez el impacto financiero, tomar decisiones y destacar en un panorama empresarial cambiante.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Descubra cómo con la demostración rápida",    
    },
       "Quão conectado é o processo de orçamento e planejamento da sua organização?": {
        header: "Planejamento de negócios integrado ",
        negCopy:"Use um planejamento sofisticado de longo prazo e modelagem estratégica para analisar rapidamente o impacto financeiro, tomar decisões informadas e ter desempenho superior em um cenário de negócios em constante evolução.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Veja como nesse tour rápido",    
    },
       "¿Qué tan conectado está el proceso de presupuesto y planificación?": {
        header: "Planificación empresarial integrada",
        negCopy:"Utiliza una sofisticada planificación a largo plazo y un modelo estratégico para analizar rápidamente el impacto financiero, tomar decisiones informadas y obtener un desempeño superior en un panorama de negocios en constante evolución.  ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-cloud-overview/index.html",
        negLinkTxt:"Descubre cómo en este recorrido rápido",    
    },
        "How do you measure which products or services are profitable?": {
        header: "Profitability",
        negCopy:"Analyze performance and control costs, and maximize profitability for each service, product, or customer.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Take a quick tour here",    
    },
        "Wie messen Sie, welche Produkte oder Services rentabel sind?": {
        header: "Rentabilität",
        negCopy:"Analysieren Sie Performance- und Kontrollkosten und maximieren Sie die Rentabilität für jeden Service, jedes Produkt oder jeden Kunden. ",
       negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Sehen Sie sich die Quick Tour hier an",   
    },
       "Comment évaluez-vous la rentabilité des produits et services ?": {
        header: "Rentabilité",
        negCopy:"Analysez vos coûts liés au contrôle et à la performance, et optimisez la rentabilité de chaque service, produit ou client.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
       "Как вы оцениваете, какие продукты или услуги являются прибыльными?": {
        header: "Рентабельность",
        negCopy:"Анализируйте затраты на производительность и управление, увеличивайте рентабельность каждой услуги, продукта или клиента.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Смотреть краткую презентацию",    
    },
       "Hangi ürün veya hizmetlerin kârlı olduğunu nasıl ölçüyorsunuz?": {
        header: "Kârlılık",
        negCopy:"Her bir hizmet, ürün veya müşteri için performansı analiz edin, maliyetleri kontrol altında tutun ve kârlılığı maksimuma çıkarın.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Buradan hızlı bir tur atın",    
    },
       "Come misurate i prodotti o servizi più profittevoli?": {
        header: "Profittabilità e redditività",
        negCopy:"Analizza le performance, controlla e ottimizza i costi, massimizza la profittabilità per ogni servizio, prodotto o cliente.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Fai un breve tour qui",    
    },
       "¿Cómo determina qué productos o servicios son rentables?": {
        header: "Rentabilidad",
        negCopy:"Analice el rendimiento, controle los costes y maximice la rentabilidad de cada servicio, producto o cliente.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Vea una demostración rápida aquí",    
    },
       "Como é medida a lucratividade de produtos ou serviços na sua organização?": {
        header: "Lucratividade",
        negCopy:"Analise o desempenho, controle os custos e maximize a lucratividade de cada serviço, produto ou cliente.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Faça um tour rápido aqui",    
    },
        "¿Cómo se mide qué productos o servicios son rentables?": {
        header: "Rentabilidad",
        negCopy:"Analiza el desempeño, controla los costos, y maximiza la rentabilidad de cada servicio, producto o cliente. ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-pcm-overview/index.html",
        negLinkTxt:"Realiza un recorrido rápido aquí",    
    },
        "What are your budgeting and forecasting capabilities?": {
        header: "Budgeting and Forecasting",
        negCopy:"Make informed decisions quickly with streamlined, collaborative and optimized planning and forecasting.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Learn how in this quick tour",    
    },
        "Über welche Finanzplanungs- und Prognosefähigkeiten verfügen Sie derzeit?": {
        header: "Budgetierung und Vorhersage",
        negCopy:"Treffen Sie schneller fundierte Entscheidungen mit rationalisierter, kollaborativer und optimierter Planung und Prognose.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Erfahren Sie in dieser Quick Tour, wie das geht",    
    },
      "Comment gérez-vous votre budget et vos prévisions ?": {
        header: "Budgétisation et prévisions",
        negCopy:"Prendre rapidement des décisions éclairées grâce à une planification et à des prévisions rationalisées, concertées et optimisées.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
      "Как в вашей компании построены процессы бюджетирования и прогнозирования?": {
        header: "Планирование бюджета и прогнозирование",
        negCopy:"Принимайте обоснованные решения быстро благодаря рационализированному, совместному и оптимизированному планированию и прогнозированию.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Ознакомьтесь с руководством, чтобы узнать, как это сделать",    
    },
      "Bütçeleme ve tahmin yetenekleriniz nelerdir?": {
        header: "Bütçe ve Planlama",
        negCopy:"Kolaylaştırılmış, işbirliğine dayalı ve optimize edilmiş planlama ve tahmin ile bilgiye dayalı kararları hızla alın.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Bu hızlı turda bunu nasıl yapacağınızı görün",    
    },
      "Come definiresti le capacità di budget e forecast della tua azienda?": {
        header: "Budgeting e forecasting",
        negCopy:"Prendere rapidamente decisioni informate grazie a una pianificazione e a previsioni semplificate, collaborative e ottimizzate.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Scopri come in questo quick tour",    
    },
      "¿De qué capacidades para presupuestos y proyecciones dispone?": {
        header: "Presupuestos y previsiones",
        negCopy:"Tomar decisiones informadas rápidamente con una planificación y previsión racionalizadas, colaborativas y optimizadas.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Averigüe cómo en la demostración rápida",    
    },
      "Quais são os seus recursos de orçamento e previsão?": {
        header: "Orçamento e Previsão",
        negCopy:"Tomar decisões informadas rapidamente com planejamento e previsão simplificados, colaborativos e otimizados.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Saiba como nesse tour rápido",    
    },
      "¿Cuáles son tus capacidades de presupuesto y pronóstico?": {
        header: "Presupuestos y previsiones",
        negCopy:"Tomar decisiones informadas rápidamente con una planificación y previsión racionalizadas, colaborativas y optimizadas.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-planning-modules-overview/index.html",
        negLinkTxt:"Descubre cómo en este recorrido rápido",    
    },
    "How do you manage master data changes to your finance systems?": {
        header: "Enterprise data management",
        negCopy:"Eliminate tedious, manual, and error-prone processes. Use a central change management platform to align your enterprise hierachy, harmonize changes efficiently, and coordinate across applications.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Take a quick tour",    
    },
    "Wie werden Änderungen an den Stammdaten in Ihren Finanzsystemen verwaltet?": {
        header: "Enterprise Data Management",
        negCopy:"Schluss mit mühsamen und fehleranfälligen Prozessen. Setzen Sie auf eine zentrales Änderungsmanagement, um die Hierarchie, Änderungen und Anwendungen zu harmonisieren.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Quick Tour ansehen",    
    },
     "Comment modifiez-vous vos données principales dans les systèmes financiers ?": {
        header: "Gestion des données d’entreprise",
        negCopy:"Supprimez les tâches manuelles fastidieuses et les processus propices aux erreurs. Utilisez une plateforme centrale pour aligner, harmoniser et coordonner.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
     "Как организовано управление изменениями основных данных в фин. системах компании?": {
        header: "Управление корпоративными данными",
        negCopy:"Исключите трудоемкие процессы, выполняемые вручную. Используйте централизованное управление изменениями для гармонизации и координирования всех процессов.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Смотреть краткую презентацию",    
    },
     "Finans sistemlerinizdeki ana veri değişikliklerini nasıl yönetiyorsunuz?": {
        header: "Kurumsal veri yönetimi",
        negCopy:"Zahmetli, manuel, hataya açık süreçleri ortadan kaldırın. Hiyerarşi, değişiklikler ve uygulamalar arası uyum için merkezi bir değişiklik yönetim platformu kullanın.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Hızlı bir tur atın",    
    },
     "Come gestite le modifiche dei master data nei vostri sistemi finanziari?": {
        header: "Gestione dei dati aziendali",
        negCopy:"Elimina i processi manuali soggetti a errore: utilizza una piattaforma centrale per gestire la governance delle strutture gerarchiche allineando le diverse applicazioni.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Fai un breve tour",    
    },
     "¿Cómo gestiona los cambios de los datos maestros en sus sistemas financieros?": {
        header: "Gestión de datos empresariales",
        negCopy:"Quite un proceso manual y propenso al error por una plataforma central de gestión de cambios para ajustar la jerarquía y coordinar las aplicaciones.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Vea una demostración rápida",    
    },
     "Como são gerenciadas as alterações de dados mestres nos seus sistemas financeiros ?": {
        header: "Gerenciamento de dados empresariais",
        negCopy:"Elimine processos cansativos, manuais e propensos a erros. Use uma plataforma central de gestão de mudanças para alinhar a hierarquia da sua organização, harmonizar as mudanças com eficiência e coordenar os aplicativos.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Faça um tour rápido",    
    },
     "¿Cómo gestionas los cambios en los datos maestros de tus sistemas financieros?": {
        header: "Gestión de datos empresariales",
        negCopy:"Elimina procesos tediosos, manuales y propensos a errores. Utiliza una plataforma central de gestión de cambios para alinear la jerarquía de tu empresa, armonizar los cambios de manera eficiente y coordinar las aplicaciones.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/epm/gqt-epm-edm-overview/index.html",
        negLinkTxt:"Realiza un recorrido rápido",    
    },
    "What does your process look like for onboarding acquired companies?": {
        header: "M&A: Onboarding of data structures",
        negCopy:"Onboard new companies and employees faster with common forecasting, headcount realignment, and optimization.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn where to start",    
    },
        "Welchen Prozess verwenden Sie für das Eingliedern übernommener Firmen?": {
        header: "Fusionen und Übernahmen: Datenstrukturen eingliedern",
        negCopy:"Gliedern Sie neue Firmen und Mitarbeiter schneller mit gängigen Prognosen, einer Neuausrichtung des Personalbestands und Optimierungen ein.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-ma-starter-kit-de",
        negLinkTxt:"Erfahren Sie, wo Sie beginnen sollten",    
    },
            "Quel processus avez-vous mis en place pour les entreprises récemment acquises ?": {
        header: "Fusions et acquisitions: Intégrer des structures de données",
        negCopy:"Intégrez rapidement de nouvelles entreprises et de nouveaux collaborateurs grâce à des prévisions, un équilibrage des effectifs et des stratégies d’optimisation communes.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-business-model-starter-kit-fr?topic=Embrace%20Business%20Model%20Innovation",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
            "Как выглядит ваш процесс интеграции приобретенных компаний?": {
        header: "Слияния и поглощения: Интеграция структуры данных",
        negCopy:"Ускорьте процесс интеграции новых компаний и сотрудников посредством прогнозирования, перераспределения трудовых ресурсов и оптимизации.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Узнать, с чего начать",    
    },
            "Satın alınan şirketlerin uyumu için nasıl bir süreç kullanıyorsunuz?": {
        header: "M&A: Veri yapılarının uyumlaştırılması",
        negCopy:"Ortak tahmin, personel sayısı ayarlama ve optimizasyonla yeni şirketlerin ve çalışanların uyumunu daha hızlı sağlayın.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Nerden başlayacağınızı öğrenin",    
    },
            "Come avviene il processo di incorporazione delle società acquisite?": {
        header: "M&A: Integrazione di strutture dati",
        negCopy:"Incorpora nuove aziende e dipendenti più rapidamente con forecast comuni, riallineamento del personale e ottimizzazione.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Impara da dove cominciare",    
    },
            "¿Cómo describiría el proceso para incorporar a las empresas adquiridas?": {
        header: "Fusiones y Adq.: incorporación de estructuras de datos",
        negCopy:"Incorpore más rápidamente nuevas empresas y empleados con proyecciones, reajustes de plantilla y optimizaciones comunes.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Averigüe por dónde empezar",    
    },
            "Como é o processo de integração das empresas adquiridas?": {
        header: "M&A: Integração de estruturas de dados",
        negCopy:"Integre novas empresas e funcionários mais rápido com previsões comuns, realinhamento de pessoal e otimização.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-ma-starter-kit-br",
        negLinkTxt:"Saiba por onde começar",    
    },
            "¿Cómo es el proceso para incorporar empresas adquiridas?": {
        header: "M&A: Incorporación de estructuras de datos",
        negCopy:"Incorpora nuevas empresas y empleados más rápidamente con pronósticos comunes, reajustes de personal y optimización.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-ma-starter-kit-sp",
        negLinkTxt:"Descubre dónde empezar",    
    },
        "How do you see your company’s approach to digitalization?": {
        header: "Digitization",
        negCopy:"Streamline and digitize processes to build a modern finance organization. Make better-informed decisions, increase productivity, and improve business outcomes.",
        negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Learn how to get started",    
    },
    "Wie schätzen Sie den Ansatz Ihres Unternehmens zur Digitalisierung ein?": {
        header: "Digitalisierung",
        negCopy:"Schaffen Sie mit straffen Digitalprozessen eine moderne Finanzorganisation. Treffen Sie fundiertere Entscheidungen, verbessern Sie Produktivität und Geschäftsergebnisse.",
        negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Erfahren Sie, wie Sie loslegen können",    
    },
        "Quelle est l’approche de votre entreprise en matière de numérisation ?": {
        header: "Numérisation",
        negCopy:"Rationalisez et numérisez les processus pour moderniser vos services financiers. Prenez des décisions éclairées, gagnez en productivité et boostez vos bénéfices.",
         negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
        "Какого подхода к цифровизации придерживается ваша компания?": {
        header: "Внедрение цифровых технологий",
        negCopy:"Оптимизируйте и оцифруйте процессы, чтобы создать современную финансовую организацию. Принимайте обоснованные решения, повышайте производительность и бизнес-результаты.",
           negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Узнать, с чего начать",    
    },
    "Şirketinizin sayısallaştırma (dijitalizasyon) yaklaşımını nasıl görüyorsunuz?": {
        header: "Sayısallaştırma",
        negCopy:"Süreçleri mali organizasyonu modernleştirecek şekilde düzenleyin ve sayısallaştırın. Bilgiye dayalı daha iyi kararlar verin, verimliliği artırın ve sonuçları iyileştirin.",
          negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Nerden başlayacağınızı öğrenin",    
    },
        "Come descriveresti l'approccio della tua azienda alla digitalizzazione?": {
        header: "Digitalizzazione",
        negCopy:"Semplifica e digitalizza i processi per avere una moderna organizzazione AFC. Prendi decisioni più informate, aumenta la produttività e migliora i risultati aziendali.",
           negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Scopri come iniziare",    
    },
        "¿Cómo describiría el enfoque de su empresa respecto a la digitalización?": {
        header: "Digitalización",
        negCopy:"Optimice y digitalice los procesos como una organización financiera moderna. Tome decisiones informadas, aumente la productividad y mejore los resultados.",
           negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Averigüe cómo empezar",    
    },
        "Como é a abordagem da sua organização em relação à digitalização?": {
        header: "Digitalização",
        negCopy:"Simplifique e digitalize processos para construir uma organização financeira moderna. Tome decisões mais bem informadas, aumente a produtividade e melhore os resultados dos negócios.",
           negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Saiba como começar",    
    },
        "¿Cómo observas el enfoque de tu empresa con respecto a la digitalización?": {
        header: "Digitalización",
        negCopy:"Racionaliza y digitaliza procesos para desarrollar una organización financiera moderna. Toma decisiones mejor informadas, aumenta la productividad y mejora los resultados comerciales.",
          negLink:"https://www.youtube.com/watch?v=AeY9h1RVnBQ&feature=emb_title",
        negLinkTxt:"Descubre cómo empezar a utilizar",    
    },
        "How efficient is your current procure-to-pay (P2P) process?": {
        header: "Procure to Pay",
        negCopy:"Leverage machine learning to automate and streamline procure-to-pay, control costs, and ensure compliance.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"See how in this quick tour",    
    },
       "Wie effizient ist der derzeitige Procure-to-Pay-Prozess (P2P)?": {
        header: "Procure-to-Pay ",
        negCopy:"Nutzen Sie Machine Learning, um Procure-to-Pay zu automatisieren und zu optimieren, Kosten zu kontrollieren und für Compliance zu sorgen.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Erfahren Sie in dieser Quick Tour, wie das geht",    
    },
           "Quelle est l’efficacité du processus d’achats actuel ?": {
        header: "Processus d’achats (Procure to Pay)",
        negCopy:"Tirez parti du machine learning pour automatiser et rationaliser vos processus d’achat, contrôler vos coûts et garantir votre conformité.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
           "Как организованы P2P-процессы, начиная от размещения заказа поставщику и до оплаты?": {
        header: "От заказа до оплаты (P2P)",
        negCopy:"Используйте возможности машинного обучения для автоматизации и оптимизации процесса закупок (от заказа до оплаты), контроля цен и обеспечения соответствия требованиям.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Смотреть краткую презентацию, чтобы узнать, как это сделать",    
    },
           "Mevcut alımdan ödemeye (P2P) süreciniz ne kadar verimli?": {
        header: "Alımdan Ödemeye (P2P)",
        negCopy:"Alımdan ödemeye sürecini otomatikleştirmek ve iyileştirmek, maliyetleri kontrol altına almak ve uygunluk sağlamak için makine öğrenimini artırın.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Bu hızlı turda bunu nasıl olacağını görün",    
    },
           "Quanto è efficiente il vostro attuale processo di Procure-to-Pay (P2P)?": {
        header: "Ciclo passivo (Procure-to-Pay)",
        negCopy:"Sfrutta il machine learning per automatizzare e semplificare il ciclo passivo Procure-to-Pay, controllare i costi e garantire la conformità.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Scopri come in questo breve tour",    
    },
           "¿Dispone actualmente de un proceso del aprovisionamiento al pago (P2P) eficaz ?": {
        header: "Aprovisionamiento al pago",
        negCopy:"Aproveche el aprendizaje automático para optimizar y automatizar los procesos de aprovisionamiento al pago, controlar los costes y garantizar las pruebas de conformidad.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Descubra cómo con la demostración rápida",    
    },
           "Qual o grau de eficiência do seu atual processo procure-to-pay (P2P)?": {
        header: "Procure-to-Pay",
        negCopy:"Aproveite o machine learning para automatizar e simplificar o processo procure-to-pay, controlar custos e garantir a conformidade.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Veja como nesse tour rápido",    
    },
           "¿Qué tan eficiente es el actual proceso de adquisición a pago (P2P)?": {
        header: "Procure-to-Pay",
        negCopy:"Aprovecha la tecnología de machine learning para automatizar y agilizar el proceso de adquisición a pago, controlar los costos y garantizar el cumplimiento.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-procurement/index.html",
        negLinkTxt:"Descubre cómo en este recorrido rápido",    
    },
        "How do you perform supplier relationship management?": {
        header: "Supplier management",
        negCopy:"Assess, qualify, and onboard new suppliers quickly to avoid supply chain disruptions.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Take a quick tour",    
    },
       "Wie organisieren Sie die Lieferantenbeziehungen?": {
        header: "Lieferantenmanagement",
        negCopy:"Schnelle Beurteilung, Qualifizierung und Eingliederung neuer Lieferanten, um Unterbrechungen der Lieferkette zu vermeiden.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Quick Tour ansehen",    
    },
           "Comment gérez-vous vos relations avec les fournisseurs ?": {
         header: "Gestion des fournisseurs",
        negCopy:"Évaluez, sélectionnez et intégrez de nouveaux fournisseurs rapidement pour éviter de perturber la supply chain.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
           "Как организован процесс управления отношениями с поставщиками в вашей компании?": {
        header: "Управление поставщиками",
        negCopy:"Быстро оценивайте, классифицируйте и начинайте работать с новыми поставщиками, чтобы избежать перебоев в цепи поставок.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Смотреть краткую презентацию",    
    },       
       "Tedarikçi ilişkisi yönetimini nasıl yürütüyorsunuz?": {
        header: "Tedarikçi yönetimi",
        negCopy:"Tedarik zinciri aksaklıklarından kaçınmak için yeni tedarikçileri hızlıca değerlendirin, niteleyin ve uyumlaştırın.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Hızlı bir tur atın",    
    },
           "Come gestisci i rapporti con i fornitori?": {
        header: "Gestione dei fornitori",
        negCopy:"Valuta, qualifica e acquisisci rapidamente nuovi fornitori per evitare interruzioni della catena di approvvigionamento.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Fai un breve tour",    
    },
           "¿Cómo gestiona las relaciones con proveedores?": {
        header: "Gestión de proveedores",
        negCopy:"Evalúe, califique e incorpore rápidamente a los nuevos proveedores para evitar interrupciones en la cadena de suministro. ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Vea una demostración rápida",    
    },
           "Como sua organização gerencia o relacionamento com os fornecedores?": {
        header: "Gestão de fornecedores",
        negCopy:"Avalie, qualifique e integre novos fornecedores rapidamente para evitar interrupções na cadeia de suprimentos. ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Faça um tour rápido",    
    },
           "¿Cómo se lleva a cabo la gestión de relaciones con los proveedores?": {
        header: "Gestión de proveedores",
        negCopy:"Evalúa, califica e incorpora nuevos proveedores rápidamente para evitar interrupciones en la cadena de suministro. ",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/scm/gqt-scm-prc-sourcing/index.html",
        negLinkTxt:"Realiza un recorrido rápido",    
    },
        "How do you manage supplier contracting and sourcing?": {
        header: "Source to Contract",
        negCopy:"Gain complete visibility into agreements, shorten cycle-times, and ensure compliance.",
        negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"See how",    
    },
      "Wie organisieren Sie die Auftragsvergabe und die Lieferantenbeschaffung?": {
        header: "Source-to-Contract",
        negCopy:"Schaffen Sie vollständige Transparenz in Verträgen, verkürzen Sie die Zykluszeiten und sorgen Sie für Compliance.",
        negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Mehr erfahren",    
    },
          "Comment gérez-vous la sélection et les contrats des fournisseurs ?": {
        header: "De la sélection à la gestion des contrats fournisseurs ",
        negCopy:"Profitez d’une totale visibilité de vos contrats, raccourcissez les cycles et veillez au respect de la conformité.",
        negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Découvrez comment",    
    },

          "Как в компании организован процесс выбора поставщиков и управления контрактами?": {
        header: "От поиска поставщика до заключения контракта",
        negCopy:"Добейтесь полной прозрачности контрактов, сократите время цикла, обеспечьте соблюдение требований.",
        negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Узнать, как это сделать",    
    },

          "Tedarikçi sözleşme ve kaynak bulma yönetimini nasıl yürütüyorsunuz?": {
        header: "Kaynaktan Sözleşmeye",
        negCopy:"Anlaşmalarda komple görünürlük (şeffaflık) sağlayın, döngü sürelerini kısaltın ve uygunluk sağlayın.",
         negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Nasıl olduğunu görün",    
    },

          "Come vengono gestiti i contratti con i fornitori e l'approvvigionamento?": {
        header: "Relazione e contratti con i fornitori",
        negCopy:"Ottieni una visibilità completa sui contratti, abbrevia le tempistiche del ciclo di Sourcing: selezione, scelta, negoziazione e contratto e assicura la conformità.",
        negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Scopri come",    
    },

          "¿Cómo gestiona la contratación y captación de proveedores?": {
        header: "Desde la negociación al contrato: S2C",
        negCopy:"Obtenga una visibilidad completa de los contratos, reduzca los ciclos y tiempos y garantice el las pruebas de conformidad.",
        negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Averigüe cómo",    
    },

          "Como sua empresa gerencia a contratação e aquisição de serviços de fornecedores?": {
        header: "Source-to-Contract",
        negCopy:"Obtenha visibilidade completa dos contratos, reduza os tempos de ciclo e garanta a conformidade.",
         negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Veja como",    
    },

          "¿Cómo se gestiona la contratación y el abastecimiento de proveedores?": {
        header: "Source-to-Contract",
        negCopy:"Obtén visibilidad completa de los acuerdos, acorta los tiempos de ciclo y garantiza el cumplimiento.",
         negLink:"https://www.oracle.com/a/ocom/docs/applications/erp/oracle-procurement-contracts-cloud-ds.pdf",
        negLinkTxt:"Ver cómo",    
    },
     "How do you manage your spend?": {
        header: "Spend management",
        negCopy:"Control your costs with real time visibility of spend information and savings opportunities.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Watch the quick tour",    
    },
     "Wie verwalten Sie Ihre Ausgaben?": {
        header: "Ausgabenmanagement",
        negCopy:"Kontrollieren Sie Ihre Kosten mit Echtzeittransparenz der Ausgabeninformationen und der Einsparpotenziale.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Sehen Sie sich diese Quick Tour an",    
    },
         "Comment gérez-vous les dépenses ?": {
        header: "Gestion des coûts",
        negCopy:"Contrôlez vos coûts et gardez une visibilité en temps réel de vos dépenses et découvrez les économies possibles.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
         "Как организован процесс управления расходами в вашей компании?": {
        header: "Управление расходами",
        negCopy:"Контролируйте цены, просматривая информацию о расходах и возможностях экономии в режиме реального времени.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Смотреть краткую презентацию",    
    },
         "Harcamalarınızı nasıl yönetiyorsunuz?": {
        header: "Harcama yönetimi",
        negCopy:"Harcama bilgileri ve tasarruf fırsatlarının gerçek zamanlı görünürlüğü ile maliyetlerinizi kontrol altında tutun.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Hızlı turu izleyin",    
    },
         "Come vengono gestite le spese?": {
        header: "Gestione della spesa",
        negCopy:"Controlla i costi grazie alla visibilità in tempo reale delle informazioni sulla spesa e sulle opportunità di risparmio.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Guarda il tour rapido",    
    },
         "¿Cómo gestiona los gastos?": {
        header: "Gestión de gastos",
        negCopy:"Controle sus costes con visibilidad en tiempo real de la información sobre los gastos y las oportunidades de ahorro.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Vea la demostración rápida",    
    },
         "Como sua organização gerencia os gastos?": {
        header: "Gestão de gastos",
        negCopy:"Controle seus custos com visibilidade em tempo real das informações sobre gastos e oportunidades de economia.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Assista ao tour rápido",    
    },
         "¿Cómo se gestionan los gastos?": {
        header: "Gestión de gastos",
        negCopy:"Controla los costos con visibilidad en tiempo real de información de gastos y oportunidades de ahorro.",
        negLink:"https://www.oracle.com/webfolder/s/quicktours/erp/gqt-erp-proc/index.html",
        negLinkTxt:"Ver recorrido rápido",    
    },
        "How fast can you change your delivery systems and processes?": {
        header: "Fulfillment & Delivery",
        negCopy:"Integrate and standardize service delivery, supply chain, manufacturing, and finance across the business.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Learn how in this quick tour",    
    },
      "Wie schnell können Sie Ihre Liefersysteme und -prozesse ändern?": {
        header: "Fulfillment und Leistungserbringung",
        negCopy:"Integrieren und standardisieren Sie Leistungserbringung, Supply Chain, Fertigung und Finanzen im gesamten Unternehmen.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Erfahren Sie in dieser Quick Tour, wie das geht",    
    },
          "Pouvez-vous adapter rapidement vos systèmes et processus de livraison ?": {
        header: "Traitement des commandes et livraison",
        negCopy:"Intégrez et harmonisez la livraison, la supply chain, la production et les services financiers dans toute l’entreprise.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Découvrez comment dans cette présentation rapide",    
    },
          "Насколько быстро вы можете внести изменения в системы и процессы поставки?": {
        header: "Обработка заказов и доставка",
        negCopy:"Интегрируйте и стандартизируйте сферы оказания услуг, цепи поставок, производства и финансов вашей компании.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Смотреть краткую презентацию, чтобы узнать, как это сделать",    
    },
          "Teslimat sistemlerinizi ve süreçlerinizi ne kadar hızlı değiştirebilirsiniz?": {
        header: "Sipariş Karşılama ve Teslimat",
        negCopy:"İşletmenin tamamında hizmet sunumu, tedarik zinciri, üretim ve finans entegrasyonu ve standartlaşmayı sağlayın.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Bu hızlı turda bunu nasıl yapacağınızı görün",    
    },
          "Quanto velocemente possono cambiare i vostri sistemi e processi di consegna?": {
        header: "Fulfillement e consegna ",
        negCopy:"Integra e standardizza l'erogazione dei servizi, la consegna dei prodotti, la supply chain, la produzione e il ciclo attivo di tutta l'azienda.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Scopri come in questo rapido tour",    
    },
          "¿Puede cambiar de forma rápida sus sistemas y procesos de entrega?": {
        header: "Ejecución y entrega",
        negCopy:"Integre y estandarice la prestación de servicios, la cadena de suministro, la fabricación y las finanzas en toda la empresa.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Averigüe cómo en la demostración rápida",    
    },
          "Com que rapidez sua organização consegue alterar sistemas e processos de entrega?": {
        header: "Logística e Entrega",
        negCopy:"Integre e padronize a entrega de serviços, a cadeia de suprimentos, a manufatura e as finanças em toda a organização.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Saiba como nesse tour rápido",    
    },
          "¿Qué tan rápido se pueden cambiar los sistemas y procesos de entrega?": {
        header: "Cumplimiento y entrega ",
        negCopy:"Integra y estandariza la prestación de servicios, la cadena de suministro, la fabricación y las finanzas en toda la empresa.",
        negLink:"https://www.oracle.com/scm/product-tours/#supply-chain-planning",
        negLinkTxt:"Descubre cómo en este recorrido rápido",    
    },
        "Which describes your internal audit & compliance processes?": {
        header: "Audit & Compliance",
        negCopy:"Integrate risk management into your culture and business processes with automated security analysis, digitized audits and compliance.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Download your starter kit",    
    },
      "Wie würden Sie Ihre internen Prüf- und Compliance-Prozesse beschreiben?": {
        header: "Interne Prüfung & Compliance",
        negCopy:"Integrieren Sie ein Risikomanagement mit automatisierter Sicherheitsanalyse, Compliance und digitalisierten Prüfungen in Ihre Unternehmenskultur und Unternehmensprozesse.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-risk-starter-kit-de",
        negLinkTxt:"Laden Sie jetzt Ihr Starter-Kit herunter",    
    },
          "Comment décririez-vous les processus d’audit interne et de conformité ?": {
        header: "Audit interne et conformité ",
        negCopy:"Intégrez la gestion des risques dans votre culture et vos processus avec une analyse automatisée de la sécurité, des audits numérisés et des normes de conformité.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-risk-starter-kit-fr",
        negLinkTxt:"Obtenez votre kit de démarrage",    
    },
          "Охарактеризуйте процессы внутреннего аудита компании и управления соответствием?": {
        header: "Аудит и обеспечение соответствия",
        negCopy:"Внедрите управление рисками в бизнес-процессы компании посредством автоматизированного контроля безопасности, цифрового аудита и соответствия требованиям.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Скачать стартовое руководство",    
    },
          "Kurum içi denetim ve uygunluk süreçlerinizi en iyi hangisi tanımlıyor?": {
        header: "Denetim ve uygunluk",
        negCopy:"Otomatik güvenlik analizleri, dijital denetimler ve uygunluk işlemleriyle kültürünüze ve işletme süreçlerinize risk yönetimini entegre edin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Başlangıç kitinizi indirin",    
    },
          "Come descrivi i processi di audit interno e conformità della tua azienda?": {
        header: "Audit interno e conformità",
        negCopy:"Integra la gestione del rischio nella cultura e nei processi aziendali, con analisi automatizzate della sicurezza, audit digitalizzati e gestione della conformità.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Scarica il tuo starter kit",    
    },
          "¿Cómo describiría los procesos de auditoría y cumplimiento?": {
        header: "Auditoría y cumplimiento",
        negCopy:"Integre la gestión de riesgos en su cultura y procesos empresariales con análisis de seguridad automatizados y auditorías y pruebas de conformidad digitalizados.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Descargue su kit de inicio",    
    },
          "Como você descreve os processos de auditoria interna e conformidade da sua empresa?": {
        header: "Auditoria interna e conformidade",
        negCopy:"Integre a gestão de riscos à sua cultura e aos seus processos de negócios com análise de segurança automatizada, auditorias e conformidade digitalizadas.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-risk-starter-kit-br",
        negLinkTxt:"Baixe seu kit inicial",    
    },
          "¿Qué aspectos describen los procesos de auditoría interna y cumplimiento?": {
        header: "Auditoría interna y cumplimiento",
        negCopy:"Integra la gestión de riesgos en tu cultura y procesos de negocio con análisis de seguridad automatizados, auditorías digitalizadas y cumplimiento.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-risk-starter-kit-sp",
        negLinkTxt:"Descarga tu kit de inicio",    
    },
        "Which describes your internal controls for fraud monitoring?": {
        header: "Fraud monitoring",
        negCopy:"Integrate risk management into your culture and business processes with automated security analysis, digitized audits and compliance.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Get your starter kit",    
    },
       "Wie würden Sie Ihre internen Kontrollen zur Betrugsüberwachung beschreiben?": {
        header: "Interne Kontrollen zur Betrugsüberwachung",
        negCopy:"Integrieren Sie ein Risikomanagement mit automatisierter Sicherheitsanalyse, Compliance und digitalisierten Prüfungen in Ihre Unternehmenskultur und Unternehmensprozesse.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-risk-starter-kit-de",
        negLinkTxt:"Holen Sie sich Ihr Starter-Kit",    
    },
           "Quels contrôles internes sont en place pour surveiller les fraudes ?": {
        header: "Contrôle des fraudes",
        negCopy:"Intégrez la gestion des risques dans votre culture et vos processus avec une analyse automatisée de la sécurité, des audits numérisés et des normes de conformité.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-risk-starter-kit-fr",
        negLinkTxt:"Obtenez votre kit de démarrage",    
    },
           "Как в вашей компании организован внутренний контроль за отслеживанием мошенничества?": {
        header: "Внутренний контроль за отслеживанием мошенничества ",
        negCopy:"Внедрите управление рисками в бизнес-процессы компании посредством автоматизированного контроля безопасности, цифрового аудита и соответствия требованиям.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Получить стартовый пакет",    
    },
           "Dolandırıcılık takibine yönelik kurum içi kontrolleri en iyi hangisi tanımlıyor?": {
        header: "Dolandırıcılık izleme",
        negCopy:"Otomatik güvenlik analizleri, dijital denetimler ve uygunluk işlemleriyle kültürünüze ve işletme süreçlerinize risk yönetimini entegre edin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Başlangıç kitinizi alın",    
    },
           "Come descrivi i vostri controlli interni per il monitoraggio delle frodi?": {
        header: "Controlli interni per il monitoraggio delle frodi",
        negCopy:"Integra la gestione del rischio nella cultura e nei processi aziendali, con analisi automatizzate della sicurezza, audit digitalizzati e gestione della conformità.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Ottieni il tuo starter kit",    
    },
           "¿Cómo describiría los procedimientos internos de control del fraude?": {
        header: "Control del fraude",
        negCopy:"Integre la gestión de riesgos en su cultura y procesos empresariales con análisis de seguridad automatizados y auditorías y pruebas de conformidad digitalizados.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Consiga su kit de inicio",    
    },
           "Como você descreve os seus controles internos da para monitoramento de fraudes?": {
        header: "Monitoramento de fraude",
        negCopy:"Integre a gestão de riscos à sua cultura e aos seus processos de negócios com análise de segurança automatizada, auditorias e conformidade digitalizadas.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-risk-starter-kit-br",
        negLinkTxt:"Obtenha seu kit inicial",    
    },
           "¿Qué aspectos describen los controles internos para el monitoreo de fraudes?": {
        header: "Monitoreo de fraudes",
        negCopy:"Integra la gestión de riesgos en tu cultura y procesos de negocio con análisis de seguridad automatizados, auditorías digitalizadas y cumplimiento.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-risk-starter-kit-sp",
        negLinkTxt:"Obtén tu kit de inicio",    
    },
    "Which describes your separation of duties & access controls?": {
        header: "Separation of duties & access controls",
        negCopy:"Integrate risk management into your culture and business processes with automated security analysis, digitized audits and compliance.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Download the starter kit here",    
    },
    "Wie würden Sie die Trennung Ihrer Pflichten und Zugangskontrollen beschreiben?": {
        header: "Trennung der Pflichten und Zugangskontrollen",
        negCopy:"Integrieren Sie ein Risikomanagement mit automatisierter Sicherheitsanalyse, Compliance und digitalisierten Prüfungen in Ihre Unternehmenskultur und Unternehmensprozesse.",
        negLink:"https://explore.oracle.com/big-moves-de/bm-risk-starter-kit-de",
        negLinkTxt:"Laden Sie das Starter-Kit hier herunter",    
    },
        "Comment décririez-vous la séparation des fonctions et le contrôle des accès ?": {
        header: "Séparation des fonctions et contrôle des accès",
        negCopy:"Intégrez la gestion des risques dans votre culture et vos processus avec une analyse automatisée de la sécurité, des audits numérisés et des normes de conformité.",
        negLink:"https://explore.oracle.com/big-moves-fr/bm-risk-starter-kit-fr",
        negLinkTxt:"Obtenez votre kit de démarrage",    
    },
        "Как в компании организованы процессы разделения обязанностей и контроля доступа?": {
        header: "Разделение обязанностей и контроль доступа",
        negCopy:"Внедрите управление рисками в бизнес-процессы компании посредством автоматизированного контроля безопасности, цифрового аудита и соответствия требованиям.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Скачать стартовое руководство",    
    },
        "Görev ve erişim kontrolleri ayrımınızı en iyi hangisi tanımlar?": {
        header: "Görevlerin ayrılması ve erişim kontrolleri",
        negCopy:"Otomatik güvenlik analizleri, dijital denetimler ve uygunluk işlemleriyle kültürünüze ve işletme süreçlerinize risk yönetimini entegre edin.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Başlangıç kitini buradan indirin",    
    },
        "Cosa descrive meglio la segregazione delle attività e il controllo degli accessi nella tua azienda?": {
        header: "Segregazione delle responsabilità e controllo degli accessi",
        negCopy:"Integra la gestione del rischio nella cultura e nei processi aziendali, con analisi automatizzate della sicurezza, audit digitalizzati e gestione della conformità.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Scarica lo starter kit qui",    
    },
        "¿Cómo describiría los controles de separación de responsabilidades y accesos?": {
        header: "Separación de responsabilidades y accesos",
        negCopy:"Integre la gestión de riesgos en su cultura y procesos empresariales con análisis de seguridad automatizados y auditorías y pruebas de conformidad digitalizados.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-risk-starter-kit?topic=Create%20a%20Risk%20Intelligent%20Culture",
        negLinkTxt:"Descargue aquí el kit de inicio",    
    },
        "Como você descreve a separação de funções e controles de acesso na sua empresa?": {
        header: "Acesso e Separação de Funções",
        negCopy:"Integre a gestão de riscos à sua cultura e aos seus processos de negócios com análise de segurança automatizada, auditorias e conformidade digitalizadas.",
        negLink:"https://explore.oracle.com/big-moves-br/bm-risk-starter-kit-br",
        negLinkTxt:"Baixe o kit inicial aqui",    
    },
        "¿Qué aspectos describen la separación de funciones y controles de acceso?": {
        header: "Acceso y separación de funciones",
        negCopy:"Integra la gestión de riesgos en tu cultura y procesos de negocio con análisis de seguridad automatizados, auditorías digitalizadas y cumplimiento.",
        negLink:"https://explore.oracle.com/big-moves-sp/bm-risk-starter-kit-sp",
        negLinkTxt:"Descarga el kit de inicio aquí",    
    },
    "checkboxqtest?": {
        header: "TestHeader",
        negCopy:"testnegcopy",
        negLink:"https://test.com",
        negLinkTxt:"testneglinktxt",    
    },
    "How do you approach product development?": {
        header: "PROJECT SELECTION AND MANAGEMENT",
        negCopy:"Use best-practice analysis to build a profitable innovation pipeline and shift your resources to strategic priorities.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How does your organization practice modularization?": {
        header: "PRODUCT DATA MANAGEMENT",
        negCopy:"Take full control of your product data with governance and synchronization from supply chain to sales and commerce.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "Do you consider SCM needs throughout the product lifecycle?": {
        header: "DESIGN WITH SUPPLY CHAIN",
        negCopy:"Drive value via close partnership with internal and external supply chain teams throughout the development stage.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "Do you address aftermarket needs in the development stage?": {
        header: "DESIGN FOR LIFECYCLE",
        negCopy:"Automatically harmonize enterprise-wide accounting into a common general ledger.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How do yo use customer feedback for product decisions?": {
        header: "DESIGN FOR CUSTOMER CENTRICITY",
        negCopy:"Gain customer insights to deliver products and services they value.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },

    "How do you manage your project resources?": {
        header: "PROJECT SELECTION AND MANAGEMENT",
        negCopy:"Use best-practice analysis to build a profitable innovation pipeline and shift your resources to strategic priorities.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "Which one best describes the SCM info in your product data?": {
        header: "PRODUCT DATA MANAGEMENT",
        negCopy:"Take full control of your product data with governance and synchronization from supply chain to sales and commerce.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How do you setup the supply chain in the development phase?": {
        header: "DESIGN WITH SUPPLY CHAIN",
        negCopy:"Drive value via close partnership with internal and external supply chain teams throughout the development stage.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "Do you design for sustainability for your products?": {
        header: "DESIGN FOR SUSTAINABILITY",
        negCopy:"Make informed decisions around product development to fulfill sustainability goals.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How do you support your products throughout their lifecycle?": {
        header: "DESIGN FOR LIFECYCLE",
        negCopy:"Evaluate full lifecycle financial impact and business models to build lifetime profitability into product design.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How do you address the root causes of customer complaints?": {
        header: "Design for customer centricity",
        negCopy:"Gain customer insights to deliver products and services they value.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },

    "How do you make decisions on your development projects?": {
        header: "PROJECT SELECTION AND MANAGEMENT",
        negCopy:"Use best-practice analysis to build a profitable innovation pipeline and shift your resources to strategic priorities.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How does your company manage product master data?": {
        header: "PRODUCT DATA MANAGEMENT",
        negCopy:"Take full control of your product data with governance and synchronization from supply chain to sales and commerce.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How do you work with the suppliers for your product?": {
        header: "DESIGN WITH SUPPLY CHAIN",
        negCopy:"Drive value via close partnership with internal and external supply chain teams throughout the development stage.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "Do you design for sustainable supply chain?": {
        header: "DESIGN FOR SUSTAINABILITY",
        negCopy:"Make informed decisions around product development to fulfill sustainability goals.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "How do you decide the financial impact of a product?": {
        header: "DESIGN FOR LIFECYCLE",
        negCopy:"Evaluate full lifecycle financial impact and business models to build lifetime profitability into product design.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
    "Do you develop for market segments or business models?": {
        header: "Design for customer centricity",
        negCopy:"Gain customer insights to deliver products and services they value.",
        negLink:"https://explore.oracle.com/big-moves-emea/bm-ma-starter-kit?topic=Capitalize%20on%20M%26A%20and%20Divestitures",
        negLinkTxt:"Learn how to get started",
    },
}
export default HEADER_MOD;